import React from 'react';
import Img from '../../../assets/app-only/images/public-layout-background.png';
import './index.scss';

const LoginIllustrations: React.FC = () => (
  <div className="illustration-background-container">
    <img src={Img} className="w-100 h-100" />
    <div className="illustration-overlay"></div>
  </div>
);

export default LoginIllustrations;
